import React from 'react';
import { ResponsiveSlider, SliderItem } from '@lux/slider';
import { getCampaignMobileImage } from '@browsing/campaign';
import { ErrorBoundary } from '@browsing/components';

import { Campaign } from '@shared/types/mylounge';

import { CampaignCardMini } from '../campaigns/components/campaign-card-mini';

interface CampaignVolumeCarouselProps {
    campaigns: Campaign[];
}

const CampaignVolumeCarousel = ({ campaigns }: CampaignVolumeCarouselProps) => {
    return (
        <ResponsiveSlider
            aria-labelledby="campaign-volumes-title"
            // TODO: A11Y - Provide localised keys.
            nextSlideLabel=""
            // TODO: A11Y - Provide localised keys.
            previousSlideLabel=""
            visibleItems={2}
            visibleItemsSm={3}
            visibleItemsMd={4}
            visibleItemsLg={6}
        >
            {campaigns.map(campaign => {
                const media = getCampaignMobileImage(campaign);

                return (
                    <ErrorBoundary
                        componentName={`CampaignVolumeCarouselCampaignCard-${campaign.campaignId}`}
                        key={campaign.campaignId}
                    >
                        <SliderItem>
                            <CampaignCardMini campaign={campaign} media={media} bgTransparent />
                        </SliderItem>
                    </ErrorBoundary>
                );
            })}
        </ResponsiveSlider>
    );
};

export default CampaignVolumeCarousel;
